module.exports = __webpack_public_path__ + "img/logo_symbol_w.c3dc8413.svg";